export type UploadFehler = { file: File; error: unknown };

export type MehrfachUploadErgebnis = {
    erfolgreich: number;
    fehlgeschlagen: UploadFehler[];
};

/** Lädt Dateien unabhängig voneinander; ein Fehler bricht die übrigen nicht ab. */
export async function uploadMehrereDokumente(
    files: readonly File[],
    upload: (file: File) => Promise<void>,
    onProgress?: (fertig: number, gesamt: number) => void,
): Promise<MehrfachUploadErgebnis> {
    let fertig = 0;
    const settled = await Promise.allSettled(
        files.map(async (file) => {
            try {
                await upload(file);
            } finally {
                fertig += 1;
                onProgress?.(fertig, files.length);
            }
        }),
    );
    const fehlgeschlagen: UploadFehler[] = [];
    settled.forEach((result, index) => {
        if (result.status === "rejected") {
            fehlgeschlagen.push({ file: files[index], error: result.reason });
        }
    });
    return { erfolgreich: files.length - fehlgeschlagen.length, fehlgeschlagen };
}

/**
 * Je fehlgeschlagener Datei eine Zeile „Name – Grund“. Der Grund ist die
 * deutsche Meldung des Uploads (z. B. „… ist 250 MB groß, erlaubt sind
 * höchstens 200 MB.“) — vorher stand nur der Name da, und niemand wusste,
 * warum (PROD-Ticket T-16).
 */
export function fehlschlaegeText(fehlgeschlagen: readonly UploadFehler[]): string {
    return fehlgeschlagen
        .map(({ file, error }) => {
            const grund = error instanceof Error && error.message ? error.message : "";
            return grund ? `• ${file.name} – ${grund}` : `• ${file.name}`;
        })
        .join("\n");
}
